import { useApi } from '@/contexts/shared/api/UseApi.composables'
import { serviceError, serviceSuccess } from '@/contexts/shared/service-response/ServiceResponse.helpers'
import type { ApiPreferenceCustomerSchemaResult2 } from '@/interfaces/Api.generated.interfaces'
import { PreferenceType, type PreferenceValue } from '@/contexts/preferences/Preferences.interfaces'
import { parsePreference } from '@/contexts/preferences/Preferences.services.helpers'
import type { ServiceResponse } from '@/contexts/shared/service-response/ServiceResponse.interfaces'

export const getPreference = async (
  key: string,
  preferenceType: PreferenceType
): Promise<ServiceResponse<PreferenceValue>> => {
  const url = `/preference/value/${key}`

  const resp = await useApi.get<ApiPreferenceCustomerSchemaResult2>(url)

  if (!resp.ok || resp?.data?.object == null) {
    return serviceError('getPreference')
  }

  return serviceSuccess(parsePreference(resp.data.object, preferenceType))
}
